// ConfettiEffect.js
var ConfettiEffect = pc.createScript('confettiEffect');

var duration = 15 * 1000;
var animationEnd = Date.now() + duration;
var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
var timeLeft = animationEnd - Date.now();

var conf1 = null;
var conf2 = null;

ConfettiEffect.prototype.initialize = function() {
    ConfettiEffect.instance = this;
    this.entity.on("destroy", this.OnDestroy,this);
    this.app.on('gameManager:updatestatus', this.status, this);
};

ConfettiEffect.prototype.createInitialVariables = function() {
    
    duration = 15 * 1000;
    animationEnd = Date.now() + duration;
    defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
    timeLeft = animationEnd - Date.now();
    
};

ConfettiEffect.prototype.status = function(stat){
    //3 win
    if(stat === 3 || stat === 9){
        this.createInitialVariables();
        this.StartEffect();
    }
};

function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
}

ConfettiEffect.prototype.StartEffect = function(){

    var interval = setInterval(function() {
        
        timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
            return clearInterval(interval);
        }

        var particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
        confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
    }, 250);
};

ConfettiEffect.prototype.OnDestroy = function(){
    timeLeft = 0;
    //confetti.reset();
    this.app.off('gameManager:updatestatus',this.status,this);
    this.entity.off("destroy", this.OnDestroy,this);
};

ConfettiEffect.prototype.DisableConfetti = function(){
    timeLeft = 0;
    animationEnd = Date.now();
};

